export const DELETE_PROJECT_NAME = "delete_project";
export const DELETE_PROJECT_DESC = `Deletes an Amethyst project via the GraphQL DeleteProject mutation.

Use only when the user explicitly requests deletion of an entire project container
(Search Analytics project, User Analytics project, or Index Worker project).
Do not use this for individual Index Worker jobs; ambiguous phrases like "delete IW" or
"delete Index Worker" should default to delete_index_worker.
Final user approval is handled by the confirmation UI.

Input:
- 'projectId' (required): GraphQL project ID to delete.
- 'expectedProjectName' (required): the exact human-readable project name you are presenting to the user for deletion. The server refuses the deletion if this does not match the project's actual stored name, so confirm the project name with the user and copy it verbatim. If the deletion is refused for a name mismatch, do NOT retry blindly — show the user the actual project name returned in the error and get explicit re-confirmation.

Notes:
- This is an irreversible, destructive operation (the project and all its contents are permanently deleted). Be certain of the exact project before calling.
- Write operation (mutation). Returns the deleted project's id, human-readable metadata,
  and helper links ('workspaceId', 'projectPath', 'projectUrl') so the assistant can guide the user afterward.`;
